export default __webpack_public_path__ + "static/media/facebook-icon-emBlue.d9290eb7.svg";